// Opens the visual mega menu (ZM) dropdowns on hover, in addition to Dawn's
// native click-to-toggle on the <details> element. New file, only loaded
// when section.settings.use_visual_menu_zm is on (see sections/header.liquid).
//
// The opacity/vertical-slide animation is driven entirely by CSS
// (.mega-menu-zm__top-li:hover .mega-menu__content, both !important so
// Dawn's own [open]-based rule can't win the specificity tie — see
// component-mega-menu-zm.css) — the browser's native :hover is immune to
// mouse speed, since it reflects actual pointer containment rather than a
// fixed timer. Earlier versions also drove that animation from JS timers,
// which raced with :hover and caused visible jumps/flicker, and used a
// fixed close delay that couldn't tell a slow-but-still-hovering mouse from
// one that had actually left.
//
// Horizontal centering is the one thing still done from JS (positionPanel
// below) rather than CSS — see its comment for why.
document.addEventListener('DOMContentLoaded', function () {
  // Icons/logos are white monochrome PNGs, so they can't be recolored by
  // CSS alone the way text/backgrounds can via customizer settings. Instead,
  // compute the perceived brightness of the customizer's background color
  // (--zm-menu-bg-color) once at load, and invert the icons (white -> black)
  // when that background is light enough that white icons would otherwise
  // vanish into it. component-mega-menu-zm.css reads the result via
  // --zm-menu-icon-filter on .mega-menu-zm__image.
  (function setIconContrast() {
    var scopeEl = document.querySelector('.mega-menu-zm__top-nav') || document.documentElement;
    var bg = getComputedStyle(scopeEl).getPropertyValue('--zm-menu-bg-color').trim();
    var hex = bg.replace('#', '');
    if (hex.length === 3) {
      hex = hex.charAt(0) + hex.charAt(0) + hex.charAt(1) + hex.charAt(1) + hex.charAt(2) + hex.charAt(2);
    }
    if (hex.length !== 6) return; // not a hex color (e.g. named color, rgba()) — leave icons as-is
    var r = parseInt(hex.substr(0, 2), 16);
    var g = parseInt(hex.substr(2, 2), 16);
    var b = parseInt(hex.substr(4, 2), 16);
    if (isNaN(r) || isNaN(g) || isNaN(b)) return;
    var perceivedBrightness = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    if (perceivedBrightness > 0.6) {
      document.documentElement.style.setProperty('--zm-menu-icon-filter', 'invert(1)');
    }
  })();

  // Every entry needs to know about every OTHER entry: when one item opens,
  // it must force-close all the others (see below), so build the full list
  // before wiring up any listeners.
  var entries = [];

  document.querySelectorAll('.mega-menu-zm__top-li').forEach(function (item) {
    var details = item.querySelector('details.mega-menu');
    // Plain links (Inicio, Cotiza tu moto — no submenu) still need to
    // force-close any open panel on hover: a panel is wide and centered on
    // the page, not aligned under its own trigger, so it can extend under
    // a NEIGHBORING plain link's column too, not just a neighboring
    // submenu item's. Confirmed by the same flicker recurring at the
    // Inicio/Marcas and Categorías/Cotiza-tu-moto boundaries once the
    // Marcas/Categorías one was fixed.
    if (!details) {
      item.addEventListener('mouseenter', function () {
        entries.forEach(function (entry) {
          entry.closeNow();
        });
      });
      return;
    }
    var summary = details.querySelector('summary');
    var content = details.querySelector('.mega-menu__content');
    if (!summary || !content) return;

    var closeTimer;

    function closeNow() {
      clearTimeout(closeTimer);
      details.removeAttribute('open');
    }

    entries.push({ details: details, closeNow: closeNow });

    // Horizontal centering was tried entirely in CSS (left:50% +
    // translateX(-50%)) and kept breaking: Dawn's [open]-based rule ties
    // our :hover rule's specificity, and the actual containing block for
    // `left` turned out to differ per menu item (confirmed directly via
    // getBoundingClientRect — Marcas' panel once rendered at x 1036-2316
    // while its own trigger sat at x 596-721). Measuring and setting an
    // exact pixel `left` here sidesteps all of that ambiguity — there's
    // nothing left to tie or differ per item.
    function positionPanel() {
      // Reset to the CSS baseline (left: 0) before measuring, otherwise a
      // previous call's correction would already be applied and the
      // measurement below would be relative to the wrong starting point.
      content.style.left = '0';
      var viewportWidth = document.documentElement.clientWidth;
      // Customizer-editable (section.settings.zm_menu_panel_max_width in
      // header.liquid, exposed as this CSS variable) — read at runtime
      // rather than hardcoded, since the actual applied width has to be
      // set from JS (not pure CSS) for positionPanel's centering math to
      // work. 990 matches the CSS fallback / setting default.
      var maxWidthSetting = parseFloat(getComputedStyle(content).getPropertyValue('--zm-menu-panel-max-width'));
      var maxWidth = maxWidthSetting || 990;
      var panelWidth = Math.min(viewportWidth - 32, maxWidth);
      content.style.width = panelWidth + 'px';
      var currentLeft = content.getBoundingClientRect().left;
      var desiredLeft = (viewportWidth - panelWidth) / 2;
      content.style.left = (desiredLeft - currentLeft) + 'px';
    }

    item.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
      // Force-close every OTHER item immediately. Panels are wide and
      // centered on the page rather than under their own trigger, so an
      // open panel can visually and geometrically extend under a
      // NEIGHBORING trigger's own column. A mouse sitting right on that
      // boundary is then simultaneously "inside" this item's open panel
      // and inside the next item's trigger column, so both items' hover
      // state can flip on and off in response to each other — confirmed
      // from a screen recording showing both "Marcas" and "Categorías"
      // showing the open (▲) caret at the same time while the cursor sat
      // still. Only one item's content should ever be [open] at a time,
      // which removes the other panel's geometry entirely so there's
      // nothing left to fight over at that boundary.
      entries.forEach(function (entry) {
        if (entry.details !== details) entry.closeNow();
      });
      // `open` must be set BEFORE measuring: a closed <details> hides its
      // content natively (display:none), so calling positionPanel() first
      // measured a zeroed-out rect and computed the wrong position — this
      // was the actual cause of the panel rendering off to the side on the
      // very first open (confirmed from a screenshot showing it clipped at
      // the left edge), which is also why the mouse then "missed" it and
      // triggered a real mouseleave/mouseenter pair right after opening.
      details.setAttribute('open', '');
      positionPanel();
    });

    item.addEventListener('mouseleave', function () {
      // Longer than the CSS transition (0.15s) so the fade-out finishes
      // before `open` is removed and the native <details> hides it outright.
      closeTimer = setTimeout(function () {
        details.removeAttribute('open');
      }, 200);
    });

    // Hover alone controls open/close. Without this, a click on the summary
    // triggers the native <details> toggle on top of the hover-driven state
    // — if hover already opened it, clicking would close it immediately.
    summary.addEventListener('click', function (e) {
      e.preventDefault();
      // Clicking still focuses the summary even with the toggle prevented;
      // without clearing it, :hover-driven CSS would leave this item stuck
      // looking active if we ever style :focus again.
      summary.blur();
    });
  });
});
